import React, { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { EmptyMatchedStateIcon } from '../../../../../../components/icons'
import { AppDispatch } from '../../../../../../store'
import { TechGrantsActions, TechGrantSelectors } from '../../../../../../store/technology'
import { EmptyState, GrantsTable } from '../../sharedComponents'

const Table_Headers = ['Grant Name', 'Funding Agency', 'Amount', 'Type', 'Due Date', 'Outcome']

export const SubmittedGrants: React.FC = () => {
  const { projectId = '' } = useParams()

  const dispatch = useDispatch<AppDispatch>()

  const paging = useSelector(TechGrantSelectors.getPaging)
  const grants = useSelector(TechGrantSelectors.makeSubmittedGrants)

  const fetchGrants = useCallback(async () => {
    const options = {
      params: {
        $limit: paging.limit,
        $skip: paging.skip,
        $sort: `createdAt -1`,
        $includes: 'grant,solicitation',
        $filter: JSON.stringify({
          status: 'selected',
          progressStatus:  'submitted'
        }),
      },
    }

    await dispatch(
      TechGrantsActions.fetchGrantsAsync({
        id: projectId,
        options,
      }),
    )
  }, [paging.limit, paging.skip, projectId, dispatch])

  useEffect(() => {
    fetchGrants().then()
  }, [fetchGrants])

  const EmptyComponent = (
    <EmptyState
      message={
        <>
          You have not submitted any grants.
        </>
      }
      icon={EmptyMatchedStateIcon}
    />
  )

  return (
    <GrantsTable
      grants={grants}
      paging={paging}
      projectId={projectId}
      currentTab="Submitted"
      fetchGrants={fetchGrants}
      tableHeader={Table_Headers}
      emptyComponent={EmptyComponent}
    />
  )
}
